import { EndpointReponseProps } from "../types";

const rawBase = process.env.REACT_APP_BASE_URL;
const rootBase =
  rawBase && rawBase.trim().length ? rawBase.trim() : "http://localhost:8080";

const baseURL = `${rootBase}/api`;
// const baseURL = "http://localhost:8080/api";

export const Endpoints = {
  GetCheckServerHealth: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/health`,
      method: "GET",
    };
  },
  GetLoginAdmin: (): EndpointReponseProps => {
    return {
      method: "POST",
      route: `${baseURL}/admin/auth/login`,
    };
  },
  GetVerifyTwoFactor: (): EndpointReponseProps => {
    return {
      method: "POST",
      route: `${baseURL}/admin/auth/verify-2fa`,
    };
  },
  ResendOTP: (): EndpointReponseProps => {
    return {
      method: "POST",
      route: `${baseURL}/admin/auth/resend-otp`,
    };
  },
  GetAdminProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/profile`,
      method: "GET",
    };
  },
  GetAdminLogout: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/logout`,
      method: "POST",
    };
  },
  RequestPasswordReset: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/request-password-reset`,
      method: "POST",
    };
  },
  ResetPassword: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/reset-password`,
      method: "POST",
    };
  },
  GetUsers: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/users${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetDevices: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    os?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.os) q.set("os", params.os);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/devices${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetAllowedUsers: (params?: {
    page?: number;
    limit?: number;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/allowed-users${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  AddAllowedUser: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/allowed-users`,
      method: "POST",
    };
  },
  RemoveAllowedUser: (email: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/allowed-users/${encodeURIComponent(email)}`,
      method: "DELETE",
    };
  },
  GetLeaderboard: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/users/leaderboard${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  ExportUsers: (params?: {
    search?: string;
    status?: string;
    sortBy?: string;
    sortDir?: string;
    startDate?: string;
    endDate?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/users/export${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  InviteUser: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/user/invite`,
      method: "POST",
    };
  },
  // Social Links
  GetSocialLinks: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    userId?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    if (params?.userId) q.set("userId", params.userId);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/social/list${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  VerifySocialLink: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/social/verify/${id}`,
    method: "PATCH",
  }),
  GetUserProfile: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/users/${id}`,
      method: "GET",
    };
  },
  GetUserDevices: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/users/${id}/devices`,
      method: "GET",
    };
  },
  GetUserSquad: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/users/${id}/squad`,
      method: "GET",
    };
  },
  GetUserActivities: (
    userId: string,
    params?: {
      page?: number;
      limit?: number;
      type?: "all" | "mission" | "withdrawal";
      startDate?: string;
      endDate?: string;
    },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.type) q.set("type", params.type);
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/users/${userId}/activities${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },

  GetUserSpotifyHistory: (
    userId: string,
    params?: { limit?: number; cursor?: string },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.cursor) q.set("cursor", params.cursor);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/users/${userId}/spotify/history${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetUserSpotifyStatus: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/users/${userId}/spotify/status`,
    method: "GET",
  }),
  UpdateUser: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/users/${id}`,
    method: "PATCH",
  }),
  ActivateUser: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/users/${id}/activate`,
    method: "POST",
  }),
  SuspendUser: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/users/${id}/suspend`,
    method: "POST",
  }),
  GetUserSuspensionHistory: (
    userId: string,
    params?: { page?: number; limit?: number },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    const qs = q.toString();
    return {
      route: `${baseURL}/users/${userId}/suspensions${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  ForceLogoutUser: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/users/${id}/force-logout`,
    method: "POST",
  }),
  DeleteUser: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/users/${id}`,
    method: "DELETE",
  }),
  GetDeletionRequests: (params?: {
    page?: number;
    limit?: number;
    status?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/deletion-requests${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  ApproveDeletionRequest: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/deletion-requests/${id}/approve`,
    method: "POST",
  }),
  GetArchivedMembers: (params?: {
    page?: number;
    limit?: number;
    reason?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.reason) q.set("reason", params.reason);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/archive${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  RestoreArchivedMember: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/archive/${userId}/restore`,
    method: "POST",
  }),
  GetAppFeedback: (params?: {
    page?: number;
    limit?: number;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    const qs = q.toString();
    return {
      route: `${baseURL}/app-feedback${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetMissions: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    type?: string;
    campaign?: string;
    category?: string;
    actionType?: string;
    sortBy?: string;
    sortDir?: string;
    isTutorial?: boolean;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.type) q.set("type", params.type);
    if (params?.campaign) q.set("campaign", params.campaign);
    if (params?.category) q.set("category", params.category);
    if (params?.actionType) q.set("actionType", params.actionType);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    if (params?.isTutorial !== undefined)
      q.set("isTutorial", String(params.isTutorial));
    const qs = q.toString();
    return {
      route: `${baseURL}/missions${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  ExportMissions: (params?: {
    search?: string;
    status?: string;
    type?: string;
    sortBy?: string;
    sortDir?: string;
    campaign?: string;
    startDate?: string;
    endDate?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.type) q.set("type", params.type);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    if (params?.campaign) q.set("campaign", params.campaign);
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/missions/export${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetMission: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/missions/${id}`,
    method: "GET",
  }),
  CreateMission: (): EndpointReponseProps => ({
    route: `${baseURL}/missions`,
    method: "POST",
  }),
  DuplicateMission: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/missions/${id}/duplicate`,
    method: "POST",
  }),
  UpdateMission: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/missions/${id}`,
    method: "PATCH",
  }),
  DeleteMission: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/missions/${id}`,
    method: "DELETE",
  }),
  BulkUpdateMissionStatus: (): EndpointReponseProps => ({
    route: `${baseURL}/missions/bulk/status`,
    method: "PATCH",
  }),
  GetMissionAttempts: (
    id: string,
    params?: {
      page?: number;
      limit?: number;
      search?: string;
      status?: string;
    },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    const qs = q.toString();
    return {
      route: `${baseURL}/missions/${id}/attempts${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  RevokeMissionAttempt: (
    missionId: string,
    attemptId: string,
  ): EndpointReponseProps => ({
    route: `${baseURL}/missions/${missionId}/attempts/${attemptId}/revoke`,
    method: "POST",
  }),

  // Campaigns
  GetCampaigns: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/campaigns${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetCampaignAnalytics: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/campaigns/${id}/analytics`,
    method: "GET",
  }),
  GetCampaign: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/campaigns/${id}`,
    method: "GET",
  }),
  CreateCampaign: (): EndpointReponseProps => ({
    route: `${baseURL}/campaigns`,
    method: "POST",
  }),
  UpdateCampaign: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/campaigns/${id}`,
    method: "PATCH",
  }),
  ExportCampaigns: (params?: {
    search?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/campaigns/export${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  DeleteCampaign: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/campaigns/${id}`,
    method: "DELETE",
  }),

  // Proofs
  GetProofs: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    platform?: string;
    userId?: string;
    search?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    if (params?.platform) q.set("platform", params.platform);
    if (params?.userId) q.set("userId", params.userId);
    if (params?.search) q.set("search", params.search);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/proofs${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetProofStats: (): EndpointReponseProps => ({
    route: `${baseURL}/proofs/stats`,
    method: "GET",
  }),
  GetProofById: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/proofs/${encodeURIComponent(id)}`,
    method: "GET",
  }),
  ApproveProof: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/proofs/${id}/review`,
    method: "PATCH",
  }),
  RejectProof: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/proofs/${id}/review`,
    method: "PATCH",
  }),
  /** Reverse & deny a wrongly-paid proof + claw back (balance may go negative). */
  ReverseProof: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/proofs/${id}/reverse`,
    method: "POST",
  }),
  /** General clawback of any amount from a user (admin/super only). */
  ClawbackUser: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/money/clawback`,
    method: "POST",
  }),
  /** Fraud review dashboard — medium-risk referral bonuses awaiting decision. */
  GetReferralReviewQueue: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/referrals/review-queue`,
    method: "GET",
  }),
  GetFrozenAccounts: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/fraud/frozen`,
    method: "GET",
  }),
  GetSurveyInsights: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/survey/insights`,
    method: "GET",
  }),
  UnfreezeAccount: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/fraud/${userId}/unfreeze`,
    method: "POST",
  }),
  RefundAccount: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/fraud/${userId}/refund`,
    method: "POST",
  }),
  ApproveReferral: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/referrals/${userId}/approve`,
    method: "POST",
  }),
  DenyReferral: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/referrals/${userId}/deny`,
    method: "POST",
  }),
  /** Float / liability snapshot — owed vs available, payouts, fraud recovery. */
  GetFloatSummary: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/finance/float`,
    method: "GET",
  }),
  /** Signup → earning → paid → retained funnel (where members drop off). */
  GetFunnel: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/analytics/funnel`,
    method: "GET",
  }),
  /** The actual people in a funnel cohort (with phone), for outreach. */
  GetFunnelCohort: (stage: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/analytics/funnel/cohort?stage=${encodeURIComponent(stage)}`,
    method: "GET",
  }),

  /** Web Push (admin dashboard — new proof alerts) */
  AdminPushVapidPublicKey: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/push/vapid-public-key`,
    method: "GET",
  }),
  AdminPushSubscribe: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/push/subscribe`,
    method: "POST",
  }),
  AdminPushUnsubscribe: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/push/unsubscribe`,
    method: "POST",
  }),

  // Withdrawals
  GetWithdrawals: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    userId?: string;
    search?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    if (params?.userId) q.set("userId", params.userId);
    if (params?.search) q.set("search", params.search);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/withdrawals${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetWithdrawalStats: (): EndpointReponseProps => ({
    route: `${baseURL}/withdrawals/stats`,
    method: "GET",
  }),
  ApproveWithdrawal: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/withdrawals/${id}/approve`,
    method: "POST",
  }),
  RejectWithdrawal: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/withdrawals/${id}/reject`,
    method: "POST",
  }),
  ExportWithdrawals: (params?: {
    status?: string;
    userId?: string;
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.status) q.set("status", params.status);
    if (params?.userId) q.set("userId", params.userId);
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/withdrawals/export${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetWithdrawalDetails: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/withdrawals/${id}/details`,
    method: "GET",
  }),

  // Invites
  GetInvites: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    search?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    if (params?.search) q.set("search", params.search);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/invites${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  CreateInvite: (): EndpointReponseProps => ({
    route: `${baseURL}/invites`,
    method: "POST",
  }),
  RevokeInvite: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/invites/${id}/revoke`,
    method: "POST",
  }),

  // Reports
  GetUsersReport: (params?: {
    startDate?: string;
    endDate?: string;
    format?: string;
    status?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.format) q.set("format", params.format);
    if (params?.status) q.set("status", params.status);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/users${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetActivitiesReport: (params?: {
    startDate?: string;
    endDate?: string;
    format?: string;
    status?: string;
    type?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.format) q.set("format", params.format);
    if (params?.status) q.set("status", params.status);
    if (params?.type) q.set("type", params.type);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/missions${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetSingleActivityReport: (
    id: string,
    params?: { startDate?: string; endDate?: string },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/missions/${id}${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetCampaignsReport: (params?: {
    startDate?: string;
    endDate?: string;
    format?: string;
    status?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.format) q.set("format", params.format);
    if (params?.status) q.set("status", params.status);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/campaigns${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetProofsReport: (params?: {
    startDate?: string;
    endDate?: string;
    format?: string;
    status?: string;
    platform?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.format) q.set("format", params.format);
    if (params?.status) q.set("status", params.status);
    if (params?.platform) q.set("platform", params.platform);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/proofs${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetWithdrawalsReport: (params?: {
    startDate?: string;
    endDate?: string;
    format?: string;
    status?: string;
    search?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.format) q.set("format", params.format);
    if (params?.status) q.set("status", params.status);
    if (params?.search) q.set("search", params.search);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/withdrawals${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetSingleCampaignReport: (
    id: string,
    params?: { startDate?: string; endDate?: string },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/campaigns/${id}${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetAuditReport: (params?: {
    startDate?: string;
    endDate?: string;
    action?: string;
    adminId?: string;
    entity?: string;
    targetId?: string;
    page?: number;
    limit?: number;
    format?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.startDate) q.set("startDate", params.startDate);
    if (params?.endDate) q.set("endDate", params.endDate);
    if (params?.action) q.set("action", params.action);
    if (params?.adminId) q.set("adminId", params.adminId);
    if (params?.entity) q.set("entity", params.entity);
    if (params?.targetId) q.set("targetId", params.targetId);
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.format) q.set("format", params.format);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/reports/audit${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetDashboardStats: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/dashboard/stats`,
    method: "GET",
  }),
  GetMonnifyBalance: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/dashboard/monnify-balance`,
    method: "GET",
  }),

  // Config / Settings
  GetConfigs: (): EndpointReponseProps => ({
    route: `${baseURL}/config`,
    method: "GET",
  }),
  GetConfigByKey: (key: string): EndpointReponseProps => ({
    route: `${baseURL}/config/${key}`,
    method: "GET",
  }),
  GetConfigsByCategory: (category: string): EndpointReponseProps => ({
    route: `${baseURL}/config/category/${category}`,
    method: "GET",
  }),
  UpdateConfig: (key: string): EndpointReponseProps => ({
    route: `${baseURL}/config/${key}`,
    method: "PATCH",
  }),
  CreateConfig: (): EndpointReponseProps => ({
    route: `${baseURL}/config`,
    method: "POST",
  }),
  DeleteConfig: (key: string): EndpointReponseProps => ({
    route: `${baseURL}/config/${key}`,
    method: "DELETE",
  }),
  InitializeConfigs: (): EndpointReponseProps => ({
    route: `${baseURL}/config/initialize`,
    method: "POST",
  }),

  // Waitlist (admin)
  GetWaitlist: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    sortBy?: string;
    sortDir?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    if (params?.sortBy) q.set("sortBy", params.sortBy);
    if (params?.sortDir) q.set("sortDir", params.sortDir);
    const qs = q.toString();
    return {
      route: `${baseURL}/waitlist${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  UpdateWaitlist: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/waitlist/${id}`,
    method: "PATCH",
  }),
  InviteWaitlist: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/waitlist/${id}/invite`,
    method: "POST",
  }),

  // Admins (Team)
  GetAdmins: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.role) q.set("role", params.role);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/manage${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  InviteAdmin: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/manage`,
    method: "POST",
  }),
  UpdateAdminPermissions: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/manage/${id}/permissions`,
    method: "PUT",
  }),
  ReinviteAdmin: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/manage/${id}/reinvite`,
    method: "POST",
  }),
  DeleteAdmin: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/manage/${id}`,
    method: "DELETE",
  }),
  UpdateAdmin: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/manage/${id}`,
    method: "PATCH",
  }),
  GetAuditLogs: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    action?: string;
    entityType?: string;
    actorAdminId?: string;
    status?: string;
    from?: string;
    to?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.action) q.set("action", params.action);
    if (params?.entityType) q.set("entityType", params.entityType);
    if (params?.actorAdminId) q.set("actorAdminId", params.actorAdminId);
    if (params?.status) q.set("status", params.status);
    if (params?.from) q.set("from", params.from);
    if (params?.to) q.set("to", params.to);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/audit-logs${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  ValidateOnboarding: (token: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/auth/onboarding/${token}`,
    method: "GET",
  }),
  CompleteOnboarding: (token: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/auth/onboarding/${token}`,
    method: "POST",
  }),
  UploadFile: (): EndpointReponseProps => ({
    route: `${baseURL}/files`,
    method: "POST",
  }),
  // Announcements
  GetAnnouncements: (params?: {
    activeOnly?: boolean;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.activeOnly) q.set("activeOnly", String(params.activeOnly));
    const qs = q.toString();
    return {
      route: `${baseURL}/announcements${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  CreateAnnouncement: (): EndpointReponseProps => ({
    route: `${baseURL}/announcements`,
    method: "POST",
  }),
  DeleteAnnouncement: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/announcements/${id}`,
    method: "DELETE",
  }),
  ToggleAnnouncementStatus: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/announcements/${id}/status`,
    method: "PATCH",
  }),
  UpdateAnnouncement: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/announcements/${id}`,
    method: "PATCH",
  }),
  BroadcastPush: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/broadcast`,
    method: "POST",
  }),
  // Scheduled Notifications
  GetScheduledNotifications: (params?: {
    page?: number;
    limit?: number;
    status?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.status) q.set("status", params.status);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/notifications/scheduled${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetUpcomingNotifications: (limit?: number): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (limit) q.set("limit", String(limit));
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/notifications/scheduled/upcoming${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetScheduledNotification: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/scheduled/${id}`,
    method: "GET",
  }),
  CreateScheduledNotification: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/scheduled`,
    method: "POST",
  }),
  UpdateScheduledNotification: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/scheduled/${id}`,
    method: "PATCH",
  }),
  CancelScheduledNotification: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/scheduled/${id}/cancel`,
    method: "POST",
  }),
  DeleteScheduledNotification: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/notifications/scheduled/${id}`,
    method: "DELETE",
  }),

  // Levels
  GetLevels: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/levels`,
    method: "GET",
  }),
  CreateLevel: (): EndpointReponseProps => ({
    route: `${baseURL}/admin/levels`,
    method: "POST",
  }),
  UpdateLevel: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/levels/${id}`,
    method: "PATCH",
  }),
  DeleteLevel: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/levels/${id}`,
    method: "DELETE",
  }),

  // Squads (admin)
  GetSquads: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    if (params?.search) q.set("search", params.search);
    if (params?.status) q.set("status", params.status);
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/squads${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  GetSquadDetails: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/squads/${id}`,
    method: "GET",
  }),
  GetSquadPointsLedger: (
    squadId: string,
    params?: { page?: number; limit?: number },
  ): EndpointReponseProps => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    const qs = q.toString();
    return {
      route: `${baseURL}/admin/squads/${squadId}/points-ledger${qs ? `?${qs}` : ""}`,
      method: "GET",
    };
  },
  AdminDisbandSquad: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/squads/${id}`,
    method: "DELETE",
  }),
  AdminRemoveMember: (
    squadId: string,
    userId: string,
  ): EndpointReponseProps => ({
    route: `${baseURL}/admin/squads/${squadId}/members/${userId}`,
    method: "DELETE",
  }),
  ResetUserCooldown: (userId: string): EndpointReponseProps => ({
    route: `${baseURL}/admin/squads/users/${userId}/reset-cooldown`,
    method: "POST",
  }),

  // ── Verification & Tier Access ──
  GetTierStats: (): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/stats`,
    method: "GET",
  }),
  GetVerificationReviews: (limit = 100): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/reviews?limit=${limit}`,
    method: "GET",
  }),
  GetUserVerification: (user: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/users/${encodeURIComponent(user)}`,
    method: "GET",
  }),
  SearchTierUsers: (q: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/search?q=${encodeURIComponent(q)}`,
    method: "GET",
  }),
  GetTierMembers: (tier: string, page = 1): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/members?tier=${encodeURIComponent(tier)}&page=${page}`,
    method: "GET",
  }),
  PreviewAccess: (user: string, mission: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/preview?user=${encodeURIComponent(user)}&mission=${mission}`,
    method: "GET",
  }),
  ReviewSocial: (socialLinkId: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/reviews/${socialLinkId}`,
    method: "POST",
  }),
  ResetSocialVerification: (socialLinkId: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/socials/${socialLinkId}/reset`,
    method: "POST",
  }),
  SetUserOverride: (user: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/users/${encodeURIComponent(user)}/override`,
    method: "POST",
  }),
  RecomputeTier: (user: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/users/${encodeURIComponent(user)}/recompute`,
    method: "POST",
  }),
  SetMissionAccess: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/missions/${id}`,
    method: "PATCH",
  }),
  OpenMissionToAll: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/missions/${id}/open`,
    method: "POST",
  }),
  SetMissionCohort: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/missions/${id}/cohort`,
    method: "PUT",
  }),
  SetMissionBlock: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/missions/${id}/block`,
    method: "PUT",
  }),
  SetCampaignAccess: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/campaigns/${id}`,
    method: "PATCH",
  }),
  OpenCampaignToAll: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/campaigns/${id}/open`,
    method: "POST",
  }),
  SetCampaignCohort: (id: string): EndpointReponseProps => ({
    route: `${baseURL}/tier-access/campaigns/${id}/cohort`,
    method: "PUT",
  }),
};
